export default __webpack_public_path__ + "static/media/logo6 white animated.702f45b9.svg";